import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from './axiosSetup';
import cfg from '../config';

const PasswordReset = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const handleRequest = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        try {
            await axios.post('/api/request-password-reset', { email });
            setDone(true);
            setMessage('Falls ein Account mit dieser E-Mail existiert, wurde eine E-Mail verschickt.');
            setIsError(false);
        } catch {
            setMessage('Fehler beim Senden. Bitte versuche es später erneut.');
            setIsError(true);
        } finally {
            setLoading(false);
        }
    };

    const handleReset = async (e) => {
        e.preventDefault();
        if (password !== confirm) {
            setMessage('Die Passwörter stimmen nicht überein.');
            setIsError(true);
            return;
        }
        setLoading(true);
        setMessage('');
        try {
            await axios.post('/api/reset-password', { token, password });
            setDone(true);
            setMessage('Passwort erfolgreich geändert. Du wirst zum Login weitergeleitet…');
            setIsError(false);
            setTimeout(() => navigate('/login'), 2500);
        } catch (err) {
            setMessage(err.response?.data?.message || 'Ungültiger oder abgelaufener Link.');
            setIsError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="d-flex flex-column min-vh-100"
            style={{
                backgroundImage: "url('/assets/img/narrenzunft-bg.jpg')",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <div className="container d-flex justify-content-center align-items-center flex-grow-1">
                <form
                    onSubmit={token ? handleReset : handleRequest}
                    className="bg-dark text-light p-4 rounded shadow-lg w-100"
                    style={{ maxWidth: '440px', opacity: 0.95 }}
                >
                    <h2 className="text-center mb-4">Passwort zurücksetzen</h2>
                    <p className="text-center text-secondary small mb-4">
                        {cfg.orgName}
                    </p>

                    {!token ? (
                        <>
                            <p className="small mb-3">
                                Gib deine E-Mail-Adresse ein. Falls ein Account existiert, erhältst du einen Link zum Zurücksetzen.
                            </p>
                            <div className="mb-3">
                                <label className="form-label">E-Mail</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    required
                                    disabled={done}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="mb-3">
                                <label className="form-label">Neues Passwort</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    required
                                    minLength={8}
                                    disabled={done}
                                />
                                <div className="form-text text-secondary">Mindestens 8 Zeichen, 1 Buchstabe, 1 Zahl</div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Passwort bestätigen</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={confirm}
                                    onChange={e => setConfirm(e.target.value)}
                                    required
                                    disabled={done}
                                />
                            </div>
                        </>
                    )}

                    {message && (
                        <div className={`alert alert-${isError ? 'danger' : 'success'} py-2`}>{message}</div>
                    )}

                    {!done && (
                        <button type="submit" className="btn btn-warning w-100" disabled={loading}>
                            {loading ? 'Bitte warten…' : token ? 'Passwort ändern' : 'Link anfordern'}
                        </button>
                    )}

                    <div className="text-center mt-3">
                        <Link to="/login" className="text-secondary small">Zurück zum Login</Link>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PasswordReset;
